import { useRouter } from '@tanstack/react-router'
import { type RefObject, useEffect } from 'react'

export function useContentFocus(content: RefObject<HTMLElement | null>) {
  const router = useRouter()

  useEffect(
    () =>
      router.subscribe('onRendered', ({ fromLocation, toLocation }) => {
        if (fromLocation === undefined) return
        if (fromLocation.pathname === toLocation.pathname) return

        content.current?.focus({ preventScroll: true })
      }),
    [router, content],
  )
}
